<template>
  <a-card :bordered="false">
    <list v-show="showList" ref="listComponent" @onEdit="handleEdit"></list>
    <edit v-if="!showList" :record="record" @onGoBack="handleGoBack"></edit>
  </a-card>
</template>

<script>

// 动态切换组件
import List from './TraveldocList'
import Edit from './TraveldocEdit'

export default {
  name: 'TraveldocPage',
  components: {
    List,
    Edit
  },
  data () {
    return {
      record: '',
      // 是否显示List
      showList: true
    }
  },
  created () {
  },
  methods: {
    handleEdit (record) {
      this.record = record || ''
      this.showList = false
    },
    handleGoBack () {
      this.record = ''
      this.$refs.listComponent.refreshCurrentPage()
      this.showList = true
    }
  },
  watch: {
    '$route.path' () {
      this.record = ''
      this.showList = true
    }
  }
}
</script>
